// 步骤时间线：当前运行每步的标签、时间、截图缩略图；门户签名变化的步骤标红
import type { RunDTO, TimelineEvent } from "@csp/shared";
import { useMediaToken } from "../lib/media";
import { fmtDateTime, fmtTime } from "../lib/format";
import { mediaUrl } from "../lib/net";
import { Badge } from "./Badges";
import { useLightbox } from "./Lightbox";

export function StepTimeline({ run }: { run: RunDTO }) {
  const lb = useLightbox();
  const token = useMediaToken();
  if (!run.steps.length) return <p className="muted">还没有步骤记录。</p>;
  return (
    <>
      <ol className="steps" data-testid="steps">
        {run.steps.map((s, i) => {
          const src = mediaUrl(s.screenshotUrl, token);
          const isChanged = !!s.sigChanged;
          return (
            <li key={`${s.k}-${i}`} className={isChanged ? "changed" : ""}>
              <span className="k">
                {s.k}/{s.n}
              </span>
              <span style={{ flex: 1 }}>
                <div>
                  <b translate={s.label ? "no" : undefined}>{s.label || "（无标签）"}</b>
                  {isChanged && (
                    <>
                      {" "}
                      <Badge tone="red">页面和以前不同</Badge>
                    </>
                  )}
                </div>
                <div className="small muted" title={fmtDateTime(s.startedAt)}>
                  {fmtTime(s.startedAt)}
                </div>
              </span>
              {src && <img className="thumb" src={src} alt={`第 ${s.k} 步截图`} onClick={() => lb.open(src)} />}
            </li>
          );
        })}
      </ol>
      {lb.node}
    </>
  );
}

export function EventTimeline({ events }: { events: TimelineEvent[] }) {
  const list = [...events].reverse();
  return (
    <ul className="events" data-testid="events">
      {list.map((e, i) => (
        <li key={i}>
          <span className="muted small nowrap" title={fmtDateTime(e.at)}>
            {fmtTime(e.at)}
          </span>
          <span translate="no">
            {e.who && <b>{e.who}：</b>}
            {e.text}
          </span>
        </li>
      ))}
    </ul>
  );
}
